<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HubExpertRessourcesPreparerRdvDecouverte'
});
</script>
<template>
  <ka-container
    code="expert-ressource-1-rdv-decouverte"
    :data="page.$info.expertRessource1RdvDecouverte">
    <!-- Container page -->
    <ka-container code="container-page">
      <!-- Container -->
      <ka-container code="container">
        <ka-text
          code="lt-toutes-les-ressources"
          :options="{
            href: { name: `hub-expert-Ressources` },
            click: page.ltToutesLesRessourcesClick
          }"
          :xs="{ hidden: null }">
          <span v-html="t('expertRessource1RdvDecouverte.containerPage.container.ltToutesLesRessources.value', `< Toutes les ressources`)" />
        </ka-text>
        <ka-text code="preparer-mon-1-er">
          <h1 v-html="t('expertRessource1RdvDecouverte.containerPage.container.preparerMon1Er.value', `<strong>Préparer mon 1 er </strong><br><strong>rendez-vous découverte</strong>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-1" />
      </ka-container>
      <!-- Container -->
      <ka-container code="container-2">
        <!-- Les infos -->
        <ka-container code="les-infos">
          <ka-text code="en-bref">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.lesInfos.enBref.value', `En bref`)" />
          </ka-text>
          <ka-text code="dun-point-de-vue-pratique">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.lesInfos.dunPointDeVuePratique.value', `D'un point de vue pratique, l'entretien découverte doit vous permettre d'identifier les besoins et les objectifs de l'entreprise ainsi que valider votre légitimité sur les sujets à traiter. Cet échange est le pilier du lancement de la formation. D'un point de vue humain, il vous permet de valider que le courant passe bien. <br> <br>À l'issue de cet échange vous devrez rédiger un <a href='/hub-expert/ressources/rediger-programme-de-formation'><span style='color:#D93174FF;'>PROGRAMME DE FORMATION</span></a><span style='color:#D93174FF;'>*</span>, c'est pourquoi il est essentiel d'en sortir avec un diagnostic du besoin.`)" />
          </ka-text>
          <ka-text code="pour-rediger-le">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.lesInfos.pourRedigerLe.value', `<i>* Pour rédiger le programme de formation, Matchers vous fournira un template. </i>`)" />
          </ka-text>
          <ka-text code="les-informations-que">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.lesInfos.lesInformationsQue.value', `<strong>Les informations que vous devez obtenir</strong>`)" />
          </ka-text>
          <ka-text code="voici-plusieurs-elements">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.lesInfos.voiciPlusieursElements.value', `Voici plusieurs éléments clés à fournir à l'équipe Matchers à la suite de votre échange. Ces éléments vous faciliteront la rédaction du programme de formation et permettront à Matchers de monter le dossier de formation. `)" />
          </ka-text>
          <BlocTodoPictoTexte instance-class="bloc-todo-picto-texte--p44" />
          <BlocTodoPictoTexte
            instance-class="element-1--p44"
            text="Estimer, avec l'entreprise, la durée de la formation" />
          <BlocTodoPictoTexte
            instance-class="element-2--p44"
            text="La date de démarrage souhaitée" />
          <BlocTodoPictoTexte
            instance-class="element-3--p44"
            text="Le rythme de la formation (sessions de 2h toutes les semaines...)" />
          <BlocTodoPictoTexte
            instance-class="element-4--p44"
            text="Les prérequis (ex : licence à un outil nécessaire)" />
          <BlocTodoPictoTexte
            instance-class="element-5--p44"
            text="Combien de personnes souhaitent participer à la formation ?" />
        </ka-container>
        <ka-text code="titre">
          <h2 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.titre.value', `Le contexte d’un entretien découverte`)" />
        </ka-text>
        <ka-text code="il-sagit-dun-premier">
          <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.ilSagitDunPremier.value', `<p>Il s’agit d’un premier échange pour en savoir plus sur le projet de l'entreprise et présenter vos compétences. Au stade de l’entretien découverte, les contours de la formation de l’entreprise ne sont pas toujours déterminés. Le(s) potentiel(s) intéressé(s) par la formation peut entreprendre une rencontre avec vous pour une formation avec différents buts. Voici quelques exemples :<br> </p><ul><li><strong>Être accompagné sur un objectif bien précis : </strong><i>Décrocher une levée de fond, monter un dossier pour répondre à un appel d’offre.</i></li></ul><p> </p><ul><li><strong>Être guidé de A à Z dans l’un de ses projets :</strong> <i>La refonte de son site internet, la mise en conformité de ses produits en vue d’un export à l’international, sa mise en conformité RGPD.</i></li></ul><p> </p><ul><li><strong>Être aiguillé dans la mise en place d’une stratégie :</strong><i> La création d’un blog dans l’optique d’améliorer le trafic de son site, créer de l’engagement à travers ses réseaux sociaux.</i></li></ul><p> </p><ul><li><strong>Être guidé pour résoudre une problématique :</strong> <i>Réduire les délais de réponse du SAV pour optimiser l’expérience client, augmenter son taux de conversion, automatiser sa prospection digitale pour gagner en efficacité, résoudre un conflit interne.</i></li></ul>`)" />
        </ka-text>
        <ka-text code="k-4-etapes">
          <h2 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.k4Etapes.value', `Les 4 étapes d’un entretien découverte ✅`)" />
        </ka-text>
        <!-- Etapes -->
        <ka-container
          code="etapes"
          :options="{ click: page.etapesClick }"
          inner>
          <!-- Etape 1 -->
          <ka-container code="etape-1">
            <ka-text code="tour-de-table">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.etape1.tourDeTable.value', `Tour de table`)" />
            </ka-text>
            <ka-text code="presentation-de-lentreprise">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.etape1.presentationDeLentreprise.value', `Présentation de l’entreprise et de l’expert.`)" />
            </ka-text>
          </ka-container>
          <!-- Etape 1 -->
          <ka-container code="container-3">
            <ka-text code="le-projet">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container3.leProjet.value', `Le projet`)" />
            </ka-text>
            <ka-text code="presentation-du-besoin">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container3.presentationDuBesoin.value', `Présentation du besoin et des objectifs.`)" />
            </ka-text>
          </ka-container>
          <!-- Etape 1 -->
          <ka-container code="container-4">
            <ka-text code="les-competences-de">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container4.lesCompetencesDe.value', `Les compétences <br>de l'expert`)" />
            </ka-text>
            <ka-text code="realisations-de-lexpert">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container4.realisationsDeLexpert.value', `Réalisations de l’expert en rapport avec cette thématique.`)" />
            </ka-text>
          </ka-container>
          <!-- Etape 1 -->
          <ka-container code="container-5">
            <ka-text code="le-s-objectif-s">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container5.leSObjectifS.value', `Le(s) objectif(s)`)" />
            </ka-text>
            <ka-text code="leurs-attentes-sont-elles">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.etapes.container5.leursAttentesSontElles.value', `Leurs attentes sont-elles claires ou à définir ensemble ? Qu’attendent-ils de leur formation avec vous ?`)" />
            </ka-text>
          </ka-container>
          <!-- Bar-horizontale -->
          <ka-container code="bar-horizontale" />
        </ka-container>
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Matchers vous aide à préparer votre rendez-vous découverte avec les collaborateurs de l'entreprise que vous devez former`
          }"
          value="https://ucarecdn.com/95f2de5c-86ec-4bcb-9aee-070f728f23b9/" />
        <ka-text code="k-6-conseils">
          <h2 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.k6Conseils.value', `Nos 6 conseils pour un échange réussi 👌`)" />
        </ka-text>
        <!-- conseils déroulent -->
        <ka-container code="conseils-deroulent">
          <!-- Conteneur question -->
          <ka-container code="conteneur-question">
            <!-- Deroulent -->
            <ka-container
              code="deroulent"
              :options="{
                click: page.deroulentClick,
                $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
              }"
              :selected="{ click: page.deroulentClickWhenSelected }">
              <!-- placement -->
              <ka-container code="placement">
                <ka-text code="k-1-se-renseigner-sans">
                  <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.conteneurQuestion.deroulent.placement.k1SeRenseignerSans.value', `1. Se renseigner sans se lancer dans un audit approfondi`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.conteneurQuestion.deroulent.placement.k1SeRenseignerSans.xs.value', `<strong>1. Se renseigner sans se lancer dans un audit approfondi</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 1 -->
            <ka-container
              code="question-1"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="etre-familier-avec">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.conteneurQuestion.question1.etreFamilierAvec.value', `Être familier avec l’activité et le secteur de l’entreprise vous permettra d’<strong>alimenter l’échange</strong> lors de l’entretien découverte. Vos questions seront plus précises et vous pourrez plus rapidement vous faire une idée de l’accompagnement nécessaire.<br><br><strong>Attention néanmoins à ne pas y consacrer trop de temps. </strong>Votre collaboration n’est pas encore confirmée, il s’agit simplement d’un premier échange.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-6">
            <!-- Deroulent -->
            <ka-container
              code="container-7"
              :options="{
                click: page.container7Click,
                $state: { selected: $isEqual(page.$elements['question-2']?.style.hidden, page.$constants.question2Hidden) }
              }"
              :selected="{ click: page.container7ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-8">
                <ka-text code="k-2-prendre-les-choses">
                  <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container6.container7.container8.k2PrendreLesChoses.value', `2. Prendre les choses en main : guider l’échange`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container6.container7.container8.k2PrendreLesChoses.xs.value', `<strong>2. Prendre les choses en main : guider l’échange</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 2 -->
            <ka-container
              code="question-2"
              :options="{ hidden: null }">
              <ka-text code="vous-etes-lexpert-e">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container6.question2.vousEtesLexpertE.value', `<strong>Vous êtes l’expert.e !</strong> N’hésitez pas à entamer l’échange en présentant les 4 étapes du rendez-vous découverte (décrites plus haut). <br> <br><span style='color:hsl(0, 0%, 60%);'>À ce stade l’enjeu de la formation peut être très clair et vos interlocuteurs veulent savoir si votre expérience correspond à ce qu’ils recherchent. Le déroulé de la formation peut également être très flou, exemple :<i> je souhaite m’implanter à l’étranger mais je ne sais pas par où commencer. </i></span><br><br>Dans ce cas l’échange peut davantage <strong>se focaliser sur l’objectif à atteindre</strong> et les moyens mis à disposition pour y arriver. De cette manière vous pourrez très vite constater si la mission entre dans votre champ de compétences.<strong> Votre expertise entre en jeu dès maintenant</strong>, c’est vous qui avez l’expérience des budgets, des timing, de la faisabilité de certains projets. N’hésitez pas à partager votre vision et votre sentiment.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-9">
            <!-- Deroulent -->
            <ka-container
              code="container-10"
              :options="{
                click: page.container10Click,
                $state: { selected: $isEqual(page.$elements['question-4']?.style.hidden, page.$constants.question4Hidden) }
              }"
              :selected="{ click: page.container10ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-11">
                <ka-text code="k-3-prendre-des-notes">
                  <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container9.container10.container11.k3PrendreDesNotes.value', `3. Prendre des notes`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container9.container10.container11.k3PrendreDesNotes.xs.value', `<strong>3. Prendre des notes</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 4 -->
            <ka-container
              code="question-4"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="si-la-formation-sengage">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container9.question4.siLaFormationSengage.value', `Si la formation s’engage entre vous et l’entreprise, il sera nécessaire d’élaborer <strong>un programme de formation</strong>. Matchers vous met à disposition un outil pour construire votre programme à partir d’un template. Avoir bien en tête les échanges du rendez-vous découverte vous permettra de déterminer plus facilement les étapes de la formation et les notions clés à aborder avec l’entreprise.`)" />
              </ka-text>
              <ka-text
                code="comment-rediger-un"
                :options="{
                  href: { name: `hub-expert-Ressources-rediger-programme-de-formation` },
                  click: page.commentRedigerUnClick
                }">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container9.question4.commentRedigerUn.value', `Comment rédiger un programme de formation ?`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-12">
            <!-- Deroulent -->
            <ka-container
              code="container-13"
              :options="{
                click: page.container13Click,
                $state: { selected: $isEqual(page.$elements['question-3']?.style.hidden, page.$constants.question3Hidden) }
              }"
              :selected="{ click: page.container13ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-14">
                <ka-text code="k-4-questionner-les">
                  <h3 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.container13.container14.k4QuestionnerLes.value', `4. Questionner les attentes de l'entreprise`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-3"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 3 -->
            <ka-container
              code="question-3"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="la-curiosite-nest">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.question3.laCuriositeNest.value', ` <br>La curiosité n’est pas toujours un vilain défaut !<br> <br>Après vous être présenté et avoir saisi l’activité et le secteur de l'entreprise, l'échange doit se focaliser sur <strong>l'objectif de la formation</strong>. N’hésitez pas à vous appuyer sur notre <strong>suggestion de questions</strong>.`)" />
              </ka-text>
              <ka-text code="deux-objectifs">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.question3.deuxObjectifs.value', `<strong>Deux objectifs</strong>`)" />
              </ka-text>
              <ka-text code="lobjectif-principal">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.question3.lobjectifPrincipal.value', `L’objectif principal de cet échange est de pouvoir se faire une idée de la compatibilité de votre expertise avec les attentes et les objectifs de l’entreprise. Le second objectif est d’arriver à quantifier le temps nécessaire pour la formation.`)" />
              </ka-text>
              <ka-text code="la-duree-de-la-formation">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.question3.laDureeDeLaFormation.value', `<strong>La durée de la formation</strong>`)" />
              </ka-text>
              <ka-text code="sur-certaines-missions">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container12.question3.surCertainesMissions.value', `Sur certaines missions le nombre d'heures d’une formation est pré-établi. Dans ce cas, vous n’aurez pas à déterminer la durée de la formation mais vous devrez rationaliser les attentes/objectifs de l’entreprise d’après le temps mis à disposition. <span style='color:hsl(0,0%,60%);'><i>C'est d’ailleurs un élément sur lequel vous pouvez toujours nous faire un retour ex : “trop peu de temps, il faudrait revoir les attentes du client” OU “nous pourrions ajouter un sujet à traiter pour rendre la formation plus complète”. </i></span><br> <br>Pour rappel, les séances sont réparties sur plusieurs semaines durant lesquelles l’entreprise avance en parallèle de votre accompagnement. Une formation de 20h qui démarre le 4 janvier peut donc se terminer le 8 mars si l’entreprise et l’expert organisent des sessions de formation de 2h/semaine.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-15">
            <!-- Deroulent -->
            <ka-container
              code="container-16"
              :options="{
                click: page.container16Click,
                $state: { selected: $isEqual(page.$elements['question-5']?.style.hidden, page.$constants.question5Hidden) }
              }"
              :selected="{ click: page.container16ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-17">
                <ka-text code="k-5-le-mot-de-la-fin">
                  <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container15.container16.container17.k5LeMotDeLaFin.value', `5. Le mot de la fin : conclure le rendez-vous`)" />
                  <template #xs>
                    <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container15.container16.container17.k5LeMotDeLaFin.xs.value', `<strong>5. Le mot de la fin : conclure le rendez-vous</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 5 -->
            <ka-container
              code="question-5"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="cest-effectivement">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container15.question5.cestEffectivement.value', `C’est effectivement avec l’entreprise que va se dérouler la formation mais toujours par le biais de Matchers. <br> <br><strong>À la fin de l’appel vous pouvez confirmer que vous souhaitez travailler sur le projet ou simplement dire que vous allez y réfléchir et que vous reviendrez vers Matchers pour communiquer votre décision. </strong><br> <br>Il en est de même pour l’entreprise. Ils peuvent confirmer en fin d’échange leur volonté d’engager la formation avec vous ou bien vous laisser dans l’attente d’un retour de notre part.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-18">
            <!-- Deroulent -->
            <ka-container
              code="container-19"
              :options="{
                click: page.container19Click,
                $state: { selected: $isEqual(page.$elements['question-6']?.style.hidden, page.$constants.question6Hidden) }
              }"
              :selected="{ click: page.container19ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-20">
                <ka-text code="k-6-tenir-matchers-informe">
                  <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container18.container19.container20.k6TenirMatchersInforme.value', `6. Tenir Matchers informé`)" />
                  <template #xs>
                    <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container18.container19.container20.k6TenirMatchersInforme.xs.value', `<strong>6. Tenir Matchers informé</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 6 -->
            <ka-container
              code="question-6"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="la-bonne-pratique">
                <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.conseilsDeroulent.container18.question6.laBonnePratique.value', `<span style='background-color:transparent;color:#000000;'><strong>La bonne pratique est de faire un retour immédiat à l’adresse suivante : </strong></span><span style='background-color:transparent;color:hsl(30,75%,60%);'><strong>formation&#64;matchers.fr </strong></span><span style='background-color:transparent;color:#000000;'>pour confirmer ou décliner la proposition de mission. Vous pouvez également faire le retour à votre interlocuteur Matchers par téléphone. </span><br> <br><span style='background-color:transparent;color:#000000;'>À l’issue de l’échange vous devez être informé sur la problématique, les objectifs et les enjeux de l’entreprise et avoir une idée claire des éléments sur lesquels votre expertise peut leur être utile. </span><br> <br><span style='background-color:transparent;color:#000000;'><strong>Si vos compétences ne répondent qu'en partie aux sujets abordés n’hésitez pas à nous le signaler.</strong> Nous pourrons revoir l’organisation de la formation pour ne vous faire intervenir que sur les sujets que vous maîtrisez. </span>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="text-1">
          <h2 v-html="t('expertRessource1RdvDecouverte.containerPage.container2.text1.value', `Outil :<strong> Les questions à poser ❓</strong>`)" />
        </ka-text>
        <!-- Container 3 -->
        <ka-container code="container-21">
          <!-- Container 1 -->
          <ka-container code="container-22">
            <ka-text code="pour-le-projet">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.container21.container22.pourLeProjet.value', `<strong>Pour le projet</strong>`)" />
            </ka-text>
            <ka-text code="quel-est-veritablement">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.container21.container22.quelEstVeritablement.value', `<span style='color:hsl(0,0%,60%);'>Quel est véritablement leur objectif ? </span><br><span style='color:hsl(0,0%,60%);'>Quels outils utilisez-vous ? </span><br><span style='color:hsl(0,0%,60%);'>De quelles ressources disposez-vous (membres de l’équipe, compétences, intervenants externes) ? </span><br><span style='color:hsl(0,0%,60%);'>Combien de personnes vont travailler sur ce projet ? </span><br><span style='color:hsl(0,0%,60%);'>Quel niveau ont-elles ? </span><br><span style='color:hsl(0,0%,60%);'>Y a t-il déjà eu des productions sur ce sujet ? </span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container 1 -->
          <ka-container code="container-23">
            <ka-text code="pour-lorganisation">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.container21.container23.pourLorganisation.value', `<strong>Pour l'organisation</strong>`)" />
            </ka-text>
            <ka-text code="la-regularite-des-sessions">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container2.container21.container23.laRegulariteDesSessions.value', `La régularité des sessions est un critère important de réussite d’une formation. Matchers recommande vivement que l’expert et l’entreprise fassent au minimum 1 session par semaine.<br><br><span style='color:hsl(0,0%,60%);'>Quels seraient les créneaux disponibles de votre équipe pour nos échanges ? </span><br><span style='color:hsl(0,0%,60%);'>Des sessions d’1h par semaine serait ok pour vous ? </span><br><span style='color:hsl(0,0%,60%);'>Des sessions de 2h par semaine seraient ok pour vous ?</span><br><span style='color:hsl(0,0%,60%);'>Combien de temps ont-ils à consacrer à ce sujet par semaine ?</span><br> <br><span style='color:hsl(0,0%,60%);'>Partager ses disponibilités.</span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Container -->
      <ka-container code="container-24">
        <!-- Container -->
        <ka-container
          code="container-25"
          :xs="{ hidden: null }">
          <ka-text code="text-2">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.text2.value', `<strong>Sommaire :</strong>`)" />
          </ka-text>
          <ka-text
            code="text-3"
            :options="{
              href: { hash: `#text-2--p44` },
              ariaLabel: `text`,
              click: page.text3Click
            }">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.text3.value', `<ul><li><strong>Le contexte d’un entretien découverte</strong></li></ul>`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container-26">
            <ka-text
              code="text-4"
              :options="{
                href: { hash: `#k-4-etapes--p44` },
                ariaLabel: `text`,
                click: page.text4Click
              }">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.container26.text4.value', `<ul><li><strong>Les 4 étapes d’un entretien découverte </strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icone-dev-up"
              :options="{
                click: page.iconeDevUpClick,
                $state: { selected: $isEqual(page.$elements['k-4-etapes-txt']?.style.hidden, page.$constants.k4EtapesTxtHidden) }
              }"
              :selected="{ click: page.iconeDevUpClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-4-etapes-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.container26.k4EtapesTxt.value', `<span style='color:hsl(0,0%,60%);'>1 - Les présentations</span><br><span style='color:hsl(0,0%,60%);'>2 - Le projet</span><br><span style='color:hsl(0,0%,60%);'>3 - Compétences de l'expert</span><br><span style='color:hsl(0,0%,60%);'>4 - Les attentes</span><br><span style='color:hsl(0,0%,60%);'> </span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-27">
            <ka-text
              code="text-5"
              :options="{
                href: { hash: `#k-6-conseils--p44` },
                ariaLabel: `text`,
                click: page.text5Click
              }"
              :selected="{ click: page.text5ClickWhenSelected }">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.container27.text5.value', `<ul><li><strong>Nos 6 conseils pour un échange réussi</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icon-3"
              :options="{
                click: page.icon3Click,
                $state: { selected: $isEqual(page.$elements['k-6-conseils-txt']?.style.hidden, page.$constants.k6ConseilsTxtHidden) },
                $inheritState: { selected: true }
              }"
              :selected="{ click: page.icon3ClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-6-conseils-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container25.container27.k6ConseilsTxt.value', `<span style='color:hsl(0,0%,60%);'>1 - Se renseigner sans se lancer dans un audit approfondi.</span><br><span style='color:hsl(0,0%,60%);'>2 - Prendre les choses en main : guider l’échange.</span><br><span style='color:hsl(0,0%,60%);'>3 -Prendre des notes.</span><br><span style='color:hsl(0,0%,60%);'>4 - Questionner et re-questionner le projet et les attentes de l'entreprise.</span><br><span style='color:hsl(0,0%,60%);'>5 - Le mot de la fin : conclure le rendez-vous découverte.</span><br><span style='color:hsl(0,0%,60%);'>6 - Tenir Matchers informé !</span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-28">
          <ka-text code="text-6">
            <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container28.text6.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <!-- Ressource1 -->
          <ka-container
            code="ressource-1"
            :options="{
              href: {
                name: `hub-expert-Ressources-rediger-programme-de-formation`,
                hash: `#container-page--p45`
              },
              click: page.ressource1Click
            }">
            <ka-image
              code="image-1"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `À travers plusieurs conseils, Matchers vous donne les clés pour rédiger le programme de formation que vous allez présenter à l'entreprise ayant besoin d'être formée`
              }"
              value="https://ucarecdn.com/d94a0c66-9322-47b8-afc4-5d0d564e6da8/" />
            <ka-text code="text-7">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container28.ressource1.text7.value', `<strong>Comment rédiger un programme de formation ?</strong>`)" />
            </ka-text>
          </ka-container>
          <!-- Ressource1 -->
          <ka-container
            code="container-29"
            :options="{
              href: {
                name: `hub-expert-Ressources-construire-support-de-formation`,
                hash: `#container-page--p46`
              },
              click: page.container29Click
            }">
            <ka-image
              code="image-2"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Pour une formation qualitative et claire, Matchers vous aide à créer votre support de formation`
              }"
              value="https://ucarecdn.com/a2a44513-0560-4647-bf8d-08185038c949/" />
            <ka-text code="comment-creer-mon">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container28.container29.commentCreerMon.value', `<strong>Comment créer mon support de formation ?</strong>`)" />
            </ka-text>
          </ka-container>
          <!-- Ressource1 -->
          <ka-container
            code="container-30"
            :options="{
              href: { name: `Expert-Ressources-organiser-sa-formation` },
              click: page.container30Click
            }">
            <ka-image
              code="image-3"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Pour une formation qualitative et claire, Matchers vous aide à créer votre support de formation`
              }"
              value="https://images.unsplash.com/photo-1616530834117-9167fb0d8ebc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxOXx8Y2FsZW5kYXJ8ZW58MHx8fHwxNjkyODAwMTMzfDA&ixlib=rb-4.0.3&q=80&w=1080" />
            <ka-text code="comment-bien-organiser">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container28.container30.commentBienOrganiser.value', `<strong>Comment bien organiser sa formation ?</strong>`)" />
            </ka-text>
          </ka-container>
          <!-- Ressource1 -->
          <ka-container
            code="container-31"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.container31Click
            }">
            <ka-image
              code="image-4"
              :options="{
                animationIn: `fadeIn`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                imgFit: `cover`,
                alt: `Pour une formation qualitative et claire, Matchers vous aide à créer votre support de formation`
              }"
              value="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
            <ka-text code="animer-la-formation">
              <span v-html="t('expertRessource1RdvDecouverte.containerPage.container24.container28.container31.animerLaFormation.value', `<strong>Animer la formation</strong>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { hubExpertRessourcesPreparerRdvDecouverte } from './store'
import BlocTodoPictoTexte from '~/components/BlocTodoPictoTexte/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p44')
const appData = appDataStore()
const page = hubExpertRessourcesPreparerRdvDecouverte()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
